import styles from "../index.module.css";
import { useMemo } from "react";
import { connect } from "react-redux";
import removeIcon from "../../../../assets/icons/Trash_Icon.png";
import alert from "../../../../components/AlertModal/alertModal";
import Table from "../../../../components/Table";
import moment from "moment/moment";
import {
  closeLoading,
  openLoading,
} from "../../../../components/loadingModal/loading";
import confirm from "../../../../components/ConfirmModal/confirm";
import { deleteDevice, updateDevice } from "../../../../actions/devicesActions";
import { useNavigate } from "react-router-dom";
import editIcon from "../../../../assets/icons/lapizBlue2.png";
import { useState } from "react";

const DevicesTable = ({ devices, deleteDevice, callback, updateDevice }) => {
  const navigate = useNavigate();

  const handleDelete = async (device) => {
    try {
      const validate = await confirm(
        "Confirm",
        "Are you sure you want to delete this device?"
      );
      if (validate) {
        openLoading();
        await deleteDevice({
          deviceId: device.idDevice,
          licenseId: device.idLicense,
        });
        alert("Success", "Device deleted successfully");
        navigate(-1);
      }
    } catch (error) {
      alert("Error", error.message);
    } finally {
      closeLoading();
    }
  };

  const NameCell = ({ row }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editValue, setEditValue] = useState(row.name || "");

    const handleChangeName = async () => {
      try {
        openLoading();
        await updateDevice(row.idDevice, { name: editValue });
        alert("Success", "Device name updated successfully");
        setIsEditing(false);
        await callback(true);
      } catch (error) {
        alert("Error", error.message);
      } finally {
        closeLoading();
      }
    };

    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        handleChangeName();
      } else if (event.key === "Escape") {
        setIsEditing(false);
        setEditValue(row.name || "");
      }
    };

    const handleCancel = () => {
      setIsEditing(false);
      setEditValue(row.name || "");
    };

    // Prevenir el onBlur cuando se hace click en los botones
    const handleButtonMouseDown = (e) => {
      e.preventDefault();
    };

    return (
      <div className={styles.name_container} title={row.name}>
        {isEditing ? (
          <div className={styles.edit_mode}>
            <input
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              onKeyDown={handleKeyPress}
              // onBlur={handleChangeName}
              className={`${styles.input} ${styles.edit_input}`}
              autoFocus
            />
            <div className={styles.edit_actions}>
              <div className={styles.containerb}>
                <button
                  onMouseDown={(e) => {
                    handleButtonMouseDown(e);
                    handleChangeName();
                  }}
                  className={`${styles.button} ${styles.buttonCheck}`}
                  aria-label="Aceptar o confirmar"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24">
                    <polyline
                      points="5,12 10,17 19,8"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <button
                  onMouseDown={(e) => {
                    handleButtonMouseDown(e);
                    handleCancel();
                  }}
                  className={`${styles.button} ${styles.buttonX}`}
                  aria-label="Cerrar o cancelar"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24">
                    <line
                      x1="6"
                      y1="6"
                      x2="18"
                      y2="18"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <line
                      x1="18"
                      y1="6"
                      x2="6"
                      y2="18"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.view_mode}>
            <span>{row.name}</span>
            <img
              src={editIcon}
              alt="Edit"
              className={styles.edit_icon}
              onClick={() => setIsEditing(true)}
            />
          </div>
        )}
      </div>
    );
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "hardwareId",
        header: "deviceId",
        Header: () => <div className="table-title">DEVICE ID</div>,
        accessorFn: (row) => {
          const id = row.hardwareId || "";
          const formatted =
            id
              .substring(0, 12)
              .match(/.{1,4}/g)
              ?.join("-") || "";
          return formatted;
        },
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "name",
        header: "name",
        Header: () => <div className="table-title">NAME</div>,
        accessorFn: (row) => <NameCell row={row} />,
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "activationDate",
        header: "activationDate",
        Header: () => <div className="table-title">ACTIVATION DATE</div>,
        accessorFn: (row) =>
          row.activationDate &&
          moment(row.activationDate).format("MM DD, YYYY"),
        size: 150,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "lastLogin",
        header: "lastLogin",
        Header: () => <div className="table-title">LAST LOGIN</div>,
        accessorFn: (row) =>
          row.lastLogin && moment(row.lastLogin).format("MM DD, YYYY"),
        size: 150,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "actions",
        Header: () => <div className="table-title">ACTIONS</div>,
        accessorFn: (row) => (
          <img
            src={removeIcon}
            alt="Delete"
            className="remove_icon"
            onClick={() => handleDelete(row)}
          />
        ),
        enableColumnFilter: false,
        enableSorting: false,
        grow: false,
        size: 50,
      },
    ],
    [] // ← Array de dependencias vacío
  );

  return <Table data={devices} height="53vh" columns={columns} />;
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteDevice: async (params) => {
      await dispatch(deleteDevice(params));
    },
    updateDevice: async (deviceId, data) => {
      await dispatch(updateDevice(deviceId, data));
    },
  };
};

export default connect(null, mapDispatchToProps)(DevicesTable);
